var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{key:_vm.settings.icon,staticClass:"loader vx-col w-1/2 md:w-1/3 xl:w-1/6"},[_c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":_vm.settings.icon,"statistic":_vm.settings.value,"statisticTitle":_vm.settings.label}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }